import Typography from '@mui/material/Typography'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'

export const RecordStopDialog = ({ open, handleClose, id }) => {
    const { stopRecordingMeeting, fetchMeeting, isLoadingStopRecordingMeeting } =
        useAssistantAdministrationStore((state) => state)

    const handleClickStop = async () => {
        await stopRecordingMeeting({ meetingId: id })
        await fetchMeeting()
        handleClose()
    }

    return (
        <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickStop}
            handleClose={handleClose}
            title="Остановить запись?"
            submitButtonText="Остановить запись"
            isDisabled={isLoadingStopRecordingMeeting}>
            <Typography variant="body1">Запись будет остановлена</Typography>
        </ConfirmDialogWrapper>
    )
}
